import React, { useState } from 'react';
import { Container, Row, Col, Button } from 'react-bootstrap';
import { useNavigate, useLocation } from 'react-router-dom';
import logoNavbar from '../assets/logos/logo-navbar.png';
import './LandingHeader.css';

const LandingHeader: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const isFeaturesPage = location.pathname === '/features';
  const isWhoIsThisForPage = location.pathname === '/who-is-this-for';
  const isPricingPage = location.pathname === '/pricing';

  const handleNavigation = (path: string) => {
    navigate(path);
    setMobileMenuOpen(false);
  };

  return (
    <header className="landing-header">
      <Container>
        <Row className="align-items-center">
          <Col>
            <div
              className="logo-wrapper d-flex align-items-center"
              onClick={() => handleNavigation('/')}
              style={{ cursor: 'pointer' }}
            >
              <img src={logoNavbar} alt="Revealer" className="logo-navbar" />
            </div>
          </Col>
          <Col xs="auto" className="d-none d-md-block">
            <div className="nav-item-wrapper">
              <Button
                variant="link"
                className={`text-dark nav-link-btn ${isFeaturesPage ? 'active' : ''}`}
                onClick={() => navigate('/features')}
              >
                Features
              </Button>
              {isFeaturesPage && <div className="nav-underline"></div>}
            </div>
            <div className="nav-item-wrapper">
              <Button
                variant="link"
                className={`text-dark nav-link-btn ${isWhoIsThisForPage ? 'active' : ''}`}
                onClick={() => navigate('/who-is-this-for')}
              >
                Who Is This For
              </Button>
              {isWhoIsThisForPage && <div className="nav-underline"></div>}
            </div>
            <div className="nav-item-wrapper">
              <Button
                variant="link"
                className={`text-dark nav-link-btn ${isPricingPage ? 'active' : ''}`}
                onClick={() => navigate('/pricing')}
              >
                Pricing
              </Button>
              {isPricingPage && <div className="nav-underline"></div>}
            </div>
            <Button
              variant="link"
              className="text-dark nav-link-btn"
              onClick={() => navigate('/signin')}
            >
              Sign In
            </Button>
          </Col>
          <Col xs="auto" className="d-md-none">
            <button
              className={`hamburger-btn ${mobileMenuOpen ? 'open' : ''}`}
              onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
              aria-label="Toggle navigation menu"
            >
              <span className="hamburger-line"></span>
              <span className="hamburger-line"></span>
              <span className="hamburger-line"></span>
            </button>
          </Col>
        </Row>
      </Container>
      {mobileMenuOpen && (
        <div className="mobile-menu">
          <Container>
            <div className="mobile-nav-item">
              <Button
                variant="link"
                className={`text-dark nav-link-btn ${isFeaturesPage ? 'active' : ''}`}
                onClick={() => handleNavigation('/features')}
              >
                Features
              </Button>
            </div>
            <div className="mobile-nav-item">
              <Button
                variant="link"
                className={`text-dark nav-link-btn ${isWhoIsThisForPage ? 'active' : ''}`}
                onClick={() => handleNavigation('/who-is-this-for')}
              >
                Who Is This For
              </Button>
            </div>
            <div className="mobile-nav-item">
              <Button
                variant="link"
                className={`text-dark nav-link-btn ${isPricingPage ? 'active' : ''}`}
                onClick={() => handleNavigation('/pricing')}
              >
                Pricing
              </Button>
            </div>
            <div className="mobile-nav-item">
              <Button
                variant="link"
                className="text-dark nav-link-btn"
                onClick={() => handleNavigation('/signin')}
              >
                Sign In
              </Button>
            </div>
          </Container>
        </div>
      )}
    </header>
  );
};

export default LandingHeader;